interface LoggerParams {
	[key: string]: unknown;
}

const getDeviceInfo = () => {
	const {userAgent, cookieEnabled, onLine} = navigator;
	const rtn = {userAgent, cookieEnabled, onLine, connection: {}};
	if (navigator?.connection) {
		const {downlink, downlinkMax, effectiveType, rtt, type, saveData} = navigator.connection;
		rtn.connection = {downlink, downlinkMax, effectiveType, rtt, type, saveData};
	}
	return rtn;
};

/** @description
 * stringify : serverside JSON 처리
 */
const logger = {
	info: async (data: LoggerParams) => {
		if (["local"].indexOf(process.env.BUILD as string) > -1) {
			console.info(data);
			return;
		}
		let payload = JSON.parse(JSON.stringify({...data}));
		try {
			if (typeof window !== "undefined") {
				payload = {...getDeviceInfo(), ...payload};
				fetch("/api/log/info", {
					headers: {"Content-Type": "application/json"},
					method: "POST",
					body: JSON.stringify(payload),
				});
			} else {
				globalThis.log.server?.info(payload);
			}
		} catch (e) {}
	},
	error: (data: LoggerParams) => {
		const errorObj = data?.error as {response?: {status?: number}; status?: number} | undefined;
		const status = (data?.status as number | undefined) ?? errorObj?.response?.status ?? errorObj?.status;
		if (["local"].indexOf(process.env.BUILD as string) > -1) {
			console.error(data);
			return;
		}
		// 인증 관련(401) 에러가 흘러 들어오면 info 로 강등
		if (status === 401) {
			logger.info(data);
			return;
		}
		let payload = JSON.parse(JSON.stringify({...data}));
		try {
			if (typeof window !== "undefined") {
				payload = {...getDeviceInfo(), ...payload};
				fetch("/api/log/error", {
					headers: {"Content-Type": "application/json"},
					method: "POST",
					body: JSON.stringify(payload),
				});
			} else {
				globalThis.log.server?.error(payload);
			}
		} catch (e) {}
	},
};

export default logger;
